import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  UseDisclosureReturn,
} from '@chakra-ui/react';
import { useRef } from 'react';

export function ExportConfirmationDialog2({
  modelName,
  onConfirm,
  ...props
}: IExportConfirmationDialogProps & UseDisclosureReturn) {
  const cancelRef = useRef(null);

  return (
    <AlertDialog leastDestructiveRef={cancelRef} motionPreset="slideInBottom" {...props} isCentered>
      <AlertDialogOverlay transition={'1s'} backdropFilter={'blur(5px)'} />

      <AlertDialogContent>
        <AlertDialogHeader>Exportar {modelName}?</AlertDialogHeader>
        <AlertDialogBody>
          Esse processo poderá demorar diversos minutos e não pode ser interrompido. você pode ver o progresso na aba de
          relátorios e assim completado pode baixar o arquivo. Tem certeza que deseja exportar?
        </AlertDialogBody>
        <AlertDialogFooter>
          <Button ref={cancelRef} variant="ghost" onClick={props.onClose}>
            Cancelar
          </Button>
          <Button
            onClick={() => {
              onConfirm();
              props.onClose();
            }}
            colorScheme="green"
            ml={3}
          >
            Exportar
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

interface IExportConfirmationDialogProps {
  modelName: string;
  onConfirm: () => void;
}
